<!-- eslint-disable max-len -->
<template>
  <svg width="116" height="17" viewBox="0 0 116 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M115 5C115.552 5 116 5.44772 116 6C116 6.55228 115.552 7 115 7V5ZM0 6L10 0.226497V11.7735L0 6ZM115 7H9V5H115V7Z" fill="#D1D5DB" />
  </svg>
</template>
